import Vue from 'vue'
import './plugins/axios'
import './plugins/google'
import './plugins/config'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import './plugins/logger'
import '@filters'
import './registerServiceWorker'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false
Vue.use(
  VueGtag,
  {
    // config: {
    //   id: 'G-KJ3MS6P70F',
    //   // params: {
    //   //   dimension1: 'agency',
    //   // },
    // },
    bootstrap: false,
    pageTrackerTemplate(to) {
      return {
        page_title: to.name,
        page_path: to.path,
        page_location: window.location.href,
        agency: store.getters['auth/agencies'],
      }
    },
  },
  router
)

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
